/* English account entry. Authentication is always handled by Shopify. */
(() => {
  function setEnglishLocale(rawUrl) {
    const url = new URL(rawUrl, window.location.href);
    url.searchParams.set('locale', 'en');
    return url;
  }

  function initialize(root = document) {
    const components = root.querySelectorAll('[data-cloudsy-account]');
    for (const component of components) {
      if (component.dataset.cloudsyAccountInitialized) continue;
      component.dataset.cloudsyAccountInitialized = 'true';

      const open = component.querySelector('[data-cloudsy-account-open]');
      const close = component.querySelector('[data-cloudsy-account-close]');
      const dialog = component.querySelector('[data-cloudsy-account-dialog]');
      const form = component.querySelector('[data-cloudsy-account-form]');
      const email = component.querySelector('[data-cloudsy-account-email]');
      if (!open || !dialog || !close) continue;

      open.addEventListener('click', () => {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        if (email) email.focus();
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right ||
            event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => open.focus({ preventScroll: true }));

      if (form) {
        form.addEventListener('submit', (event) => {
          if (!form.reportValidity()) return;
          event.preventDefault();
          const url = setEnglishLocale(form.dataset.loginUrl || form.action);
          url.searchParams.set('login_hint', (email?.value || '').trim());
          window.location.assign(url.toString());
        });
      }

      for (const link of component.querySelectorAll('[data-cloudsy-account-link]')) {
        link.addEventListener('click', (event) => {
          if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          window.location.assign(setEnglishLocale(link.href).toString());
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
